import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import { generatePath } from 'react-router-dom';
import {
  API_ASSET_MAPPING_FILE_PATH,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_ASSET_MAPPING_FILE_PATH,
} from '../constants';

const api = () =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: API_ASSET_MAPPING_FILE_PATH,
  });

const assetMappingFilePath = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_ASSET_MAPPING_FILE_PATH,
  responseMapping: ResponseMapping.Default,
});

export default assetMappingFilePath;
